module.exports = __webpack_public_path__ + "img/10.620fe68.jpg";